module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAACpJREFUKFNjnBcj+58BDSQtecwIEsImxzgcNKB7mBAfHBqkgGERSqTGNABpnzzpxcAPoQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/detail.png
// module id = HFjA
// module chunks = 1